export default __webpack_public_path__ + "677090d65c42bb434a43ea1731a493f6.png";